function cov_1nbzitlylx() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/RightCaretIcon.tsx";
  var hash = "b4248aa01137834de94234908385094b87c35d15";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/RightCaretIcon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 27
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 10,
          column: 8
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 27
          },
          end: {
            line: 4,
            column: 28
          }
        },
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 10,
            column: 8
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b4248aa01137834de94234908385094b87c35d15"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1nbzitlylx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1nbzitlylx();
import React from 'react';
/** @deprecated */

cov_1nbzitlylx().s[0]++;

var RightCaretIcon = function RightCaretIcon() {
  cov_1nbzitlylx().f[0]++;
  cov_1nbzitlylx().s[1]++;
  return /*#__PURE__*/React.createElement("svg", {
    width: "9",
    height: "14",
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.778846 13.4878C0.532751 13.4878 0.327675 13.3882 0.163612 13.189C0.034705 13.0249 -0.0180289 12.8374 0.00540873 12.6265C0.0288463 12.4156 0.122595 12.2456 0.286659 12.1167L7.0015 6.72025L0.321815 1.35892C0.157752 1.23002 0.0640026 1.0601 0.040565 0.849159C0.0171274 0.63822 0.0727909 0.450722 0.207557 0.286659C0.342323 0.122595 0.515173 0.0288463 0.726112 0.00540873C0.93705 -0.0180289 1.12455 0.034705 1.28861 0.163612L8.70658 6.1226C8.89408 6.27494 8.98783 6.47416 8.98783 6.72025C8.98783 6.96635 8.89408 7.16556 8.70658 7.31791L1.25346 13.312C1.11283 13.4292 0.954628 13.4878 0.778846 13.4878Z",
    fill: "#555B77"
  }));
};

export default RightCaretIcon;